export const isValidExpire = (date) => {
  const year = new Date().getFullYear().toString().substr(-2);
  const dateSplit = date.split('/');
  let isValid = false;

  if (dateSplit.length === 1) return false;

  isValid = dateSplit[0] <= 12;
  if (!isValid) return isValid;

  isValid = dateSplit[1].length === 2 && dateSplit[1] >= year;

  return isValid;
};

export const isValidNameOfCard = (name) => {
  const nameSplit = name.split(' ');
  const result = nameSplit.length >= 2;

  if (result) return nameSplit[1] !== '';

  return result;
};

export const hasInitialSpace = (name) => {
  const nameSplit = name.split(' ');

  return !!nameSplit[0];
};
